import { colorSet } from '@theme';
import { styled } from '@mui/material';

export const TableWrapper = styled('div')<{
  width?: number | string;
}>(({ width }) => ({
  width: width ? width : 1840,
  marginBottom: '32px',
  overflowX: 'auto'
}));

export const Table = styled('div')<{
  width?: number | string;
}>(({ width }) => ({
  width: width ? width : 1840
}));

export const TableHeader = styled('div')({
  height: 56,
  display: 'flex',
  alignItems: 'center',
  backgroundColor: colorSet.gray600
});

export const TableHeaderItem = styled('div')<{
  width?: number | string;
}>(({ width }) => ({
  width: width ? width : '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}));

export const TableBody = styled(`div`)({});

export const TableRow = styled(`div`)<{
  height?: number;
  hideBorderBottom?: boolean;
}>(({ height, hideBorderBottom }) => ({
  minHeight: height ?? 72,
  display: 'flex',
  borderBottom: hideBorderBottom ? 'none' : `1px solid ${colorSet.gray300}`,
  '& .MuiIconButton-root': {
    padding: 0
  }
}));

export const TableCell = styled('div')<{
  width?: number | string;
  justifyContent?: string;
  alignItems?: string;
  padding?: string;
}>(({ width, justifyContent = 'center', alignItems = 'center', padding = 0 }) => ({
  width: width ? width : '100%',
  display: 'flex',
  justifyContent: justifyContent,
  alignItems: alignItems,
  padding: padding ? padding : '16px 12px'
}));
